import React, { Fragment, ReactNode } from "react";
import { faArrowCircleLeft, faArrowCircleRight } from "@fortawesome/pro-solid-svg-icons";

import { ButtonBar, ButtonGroup, Module } from "@/components/layouts";

import AnimationList from "../animation-list";
import { ListItemAnimation } from "../animation-list/animation-list-item";
import Button from "../button";

const ANIMATIONS_PER_PAGE = 20;

type PaginatedGalleryProps = {
  page: number;
  totalAnimations: number;
  animations: ListItemAnimation[];
  linkPrefix?: string;
  extraButtons?: ReactNode;
  showPublic?: boolean;
  loading?: boolean;
  editable?: boolean;
  onPageChanged?: CallableFunction;
};

const PaginatedGallery = (props: PaginatedGalleryProps) => {
  const renderPreviousLink = () => {
    if (!props.linkPrefix) return null;
    const href = props.page === 2 ? props.linkPrefix : `${props.page - 1}`;

    const disabled = props.page === 1;

    return (
      <ButtonGroup>
        <Button
          href={href}
          disabled={disabled}
          icon={faArrowCircleLeft}
          scroll={false}
        >
          Newer
        </Button>
      </ButtonGroup>
    );
  };

  const renderNextLink = () => {
    const disabled = props.page >= props.totalAnimations / ANIMATIONS_PER_PAGE;

    return (
      <ButtonGroup align="right">
        <Button
          disabled={disabled}
          href={`${props.linkPrefix}/${props.page + 1}`}
          icon={faArrowCircleRight}
          scroll={false}
        >
          Older
        </Button>
      </ButtonGroup>
    );
  };

  const renderButtonBar = () => {
    return (
      <ButtonBar>
        {renderPreviousLink()}
        {props.extraButtons}
        {renderNextLink()}
      </ButtonBar>
    );
  };

  return (
    <Fragment>
      {renderButtonBar()}
      <Module>
        <AnimationList
          animations={props.animations}
          showPublic={props.showPublic}
        />
      </Module>
      {renderButtonBar()}
    </Fragment>
  );
};

export default PaginatedGallery;
